export enum DeviceTypeEnum {
    GPS = 'gps',
    IMEI = 'imei',
    INTEGRATION = 'integration',
}
